
import styled, { css } from 'styled-components';

export const List = styled.ul`
  && {
    padding: 0;
    margin: 0;
    list-style: none;
  }
`;

export const ListItem = styled.li`
&& {
    ${({ theme }) => css`
      a {
        color: ${theme.colors.neutral.white};
      }
      a:hover {
        color: ${theme.colors.neutral.white};
        text-decoration: underline;
      }
      svg {
        color: ${theme.colors.cta.yellow};
        float: right;
        transform: rotate(270deg);
        margin-top: 8px;
      }
      padding: 1rem 0;
      &:not(:last-child) {
        border-bottom: 1px solid ${theme.colors.blueOnBlueHeadingAccess};
      }
    `}
  }
`;
